import { BreakPoints } from '@kanda-libs/ks-design-library';

import Desktop from './Desktop';
import Mobile from './Mobile';

const ConsentSuccess: React.FunctionComponent = function () {
  return <BreakPoints mobile={<Mobile />} desktop={<Desktop />} />;
};

export default ConsentSuccess;
